var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/ui/button/button.tsx";
import classNames from 'clsx';
import * as React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../icon/icon';
import { useButtonStyles } from './useButtonStyles';

/** Customizable button element with various themes. */
const Button = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    block = false,
    children,
    disabled = false,
    icon,
    onClick,
    size = 'md',
    text,
    theme = 'secondary',
    to,
    type = 'button',
    className
  } = props;
  const themeClass = useButtonStyles({
    theme,
    block,
    disabled,
    size
  });

  const renderIcon = () => {
    if (!icon) {
      return null;
    }

    return /*#__PURE__*/React.createElement(Icon, {
      src: icon,
      className: "mr-2 w-4 h-4",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 64,
        columnNumber: 12
      }
    });
  };

  const handleClick = React.useCallback(event => {
    if (onClick && !disabled) {
      onClick(event);
    }
  }, [onClick, disabled]);

  const renderButton = () => /*#__PURE__*/React.createElement("button", {
    className: classNames(themeClass, className),
    disabled: disabled,
    onClick: handleClick,
    ref: ref,
    type: type,
    "data-testid": "button",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 74,
      columnNumber: 5
    }
  }, renderIcon(), text || children);

  if (to) {
    return /*#__PURE__*/React.createElement(Link, {
      to: to,
      tabIndex: -1,
      className: "inline-flex",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 89,
        columnNumber: 7
      }
    }, renderButton());
  }

  return renderButton();
});
export default Button;